import React from 'react';
import i18n from '@/utils/i18n';
import { FaExclamationCircle } from 'react-icons/fa';

const NotFound = () => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        flexDirection: 'column',
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <FaExclamationCircle
          className="me-2"
          style={{ fontSize: '3rem', color: '#FF0000' }}
        />
        <h1 style={{ fontSize: '3rem' }}>{i18n.t('Common:notFound')}</h1>
        <FaExclamationCircle
          className="ms-2"
          style={{ fontSize: '3rem', color: '#FF0000' }}
        />
      </div>
      <p>{i18n.t('Common:notFoundText')}</p>
    </div>
  );
};

export default NotFound;
